<template>
  <div class="flex place-items-center w-full">
    <div>
      <img class="rounded-xl w-11 h-11 object-contain" v-if="item.item.image" :src="`/media/image/${this.item.item.image}?size=sm`">
      <img class="rounded-xl w-11 h-11 object-cover" v-else src="@/assets/no-image.jpg"/>
    </div>
    <div class="grid grid-rows-2 ml-2 w-52">
      <span class="text-xs font-bold" style="-webkit-line-clamp: 1; display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden;">{{ item.item.alt_name || item.item.name }}</span>
      <span class="text-xs">{{ item.item.price }} ₽</span>
    </div>
    <div class="flex-grow"></div>
    <div class="grid grid-cols-3 w-24 relative bg-accent text-sm font-bold h-7 rounded-lg text-white content-center place-items-center">
      <button class="text-xl" @click="reduce()">-</button>
      <span>{{ item.quantity }}</span>
      <button class="text-xl" @click="increase()">+</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],

  methods: {
		reduce() {
			this.$store.dispatch('reduceItemFromBasket', this.item.item.id)
			this.changeTgBtn()
		},
    increase() {
			this.$store.dispatch('increaseItemInBasket', this.item.item.id)
			this.changeTgBtn()
		},
    changeTgBtn() {
			const basketItems = Object.values(this.$store.getters.basket)
			if (basketItems.length > 0) {
        window.WebApp.enableClosingConfirmation()
        this.$store.commit('mb_setText', `Мой заказ ${basketItems.reduce(
					(accumulator, val) => accumulator + (val.quantity * val.item.price), 0
				)} ₽`)
        this.$store.commit('mb_show')

				// window.Telegram.WebApp.isClosingConfirmationEnabled = true
				// window.Telegram.WebApp.MainButton.text = `Оплатить ${basketItems.reduce(
				// 	(accumulator, val) => accumulator + (val.quantity * val.item.price), 0
				// )} ₽`
				// window.Telegram.WebApp.MainButton.show()
			} else {
        window.WebApp.disableClosingConfirmation()
        this.$store.commit('mb_hide')

				// window.Telegram.WebApp.isClosingConfirmationEnabled = false
				// window.Telegram.WebApp.MainButton.hide()
			}
		}
  }
}
</script>

<style>

</style>
